import { ApiTagsEnum }                from "src/constants/api-tags";
import { ENDPOINTS }                  from "src/constants/api/api";
import type { ICreateCompanyRequest } from "src/store/services/admin/company/interfaces/requests.interface";
import type { ICompanyResponse,
    IGetAdminCompanyList, } from "src/store/services/admin/company/interfaces/responses.interface";
import { api } from "src/store/services/api";

export const companyApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAdminCompanyList: builder.query<{ 
      data : IGetAdminCompanyList; 
      total: number; 
    }, { search?: string; page?: number; perPage?: number } | undefined | void>({
      query: (params = {}) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/`,
        method: "GET",
        params,
      }),
      providesTags: [ApiTagsEnum.COMPANIES],
    }),
    getCompanyProfile: builder.query<ICompanyResponse, number>({
      query: (id: number) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/${id}`,
        method: "GET",
      }),
      providesTags: [ApiTagsEnum.COMPANIES],
    }),
    deleteCompany: builder.mutation<void, number>({
      query: (id: number) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [ApiTagsEnum.COMPANIES],
    }),
    createCompany: builder.mutation<ICompanyResponse, ICreateCompanyRequest>({
      query: (payload) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/`,
        method: "POST",
        body  : payload,
      }),
      invalidatesTags: [ApiTagsEnum.COMPANIES],
    }),
    updateCompany: builder.mutation<ICompanyResponse, Partial<ICreateCompanyRequest> & { id: number }>({
      query: ({ id, ...payload }) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/${id}`,
        method: "PATCH",
        body  : payload,
      }),
      invalidatesTags: [ApiTagsEnum.COMPANIES],
    }),
    updateCompanyStakeholders: builder.mutation<
      ICompanyResponse,
      {
        id          : number;
        addUsers?   : number[];
        removeUsers?: number[];
      }
    >({
      query: ({ addUsers, id, removeUsers }) => ({
        url   : `${ENDPOINTS.ADMIN.COMPANY.LIST}/${id}/users`,
        method: "PATCH",
        body  : {
          ...(addUsers && { addUsers }),
          ...(removeUsers && { removeUsers }),
        },
      }),
      invalidatesTags: [ApiTagsEnum.COMPANIES],
    }),
  }),
});

export const { useCreateCompanyMutation, 
  useDeleteCompanyMutation,
  useGetAdminCompanyListQuery,
  useGetCompanyProfileQuery,
  useUpdateCompanyMutation,
  useUpdateCompanyStakeholdersMutation, } = companyApi;
